import React from 'react';
import {
    S10PressReleasePost,
    S10PressReleasePostProps,
    MilanGradientColors,
    MilanBackgroundColors,
} from '@milanlaser/mlcomponents';
import { processBackgroundAndGradientColorMap } from '../../utils/builder.utils';
import { PaddingSize, paddingMap } from '../../utils/builderPaddingOptions';
import { useFirebaseMetrics } from '../../utils/useFirebaseMetrics';

interface S10PressReleasePostArgs
    extends Omit<S10PressReleasePostProps, 'content' | 'backgroundColor' | 'backgroundGradient'> {
    desktopPaddingTop: PaddingSize;
    desktopPaddingBottom: PaddingSize;
    mobilePaddingTop: PaddingSize;
    mobilePaddingBottom: PaddingSize;
    content: string;
    backgroundColor?: string;
    backgroundGradient: MilanGradientColors | 'None';
    backgroundImage?: string;
}

export function S10PressReleasePostSection(props: S10PressReleasePostArgs) {
    const { replaceVariables } = useFirebaseMetrics();
    const {
        desktopPaddingTop,
        desktopPaddingBottom,
        mobilePaddingTop,
        mobilePaddingBottom,
        content,
        backgroundColor,
        backgroundGradient,
        backgroundImage,
        ...restProps
    } = props;

    const topPaddingClasses = `mcl-pt-${paddingMap[mobilePaddingTop]} lg:mcl-pt-${paddingMap[desktopPaddingTop]}`;
    const bottomPaddingClasses = `mcl-pb-${paddingMap[mobilePaddingBottom]} lg:mcl-pb-${paddingMap[desktopPaddingBottom]}`;

    const processedBackgroundColor = backgroundColor === 'None' ? 'White' : backgroundColor;
    const processedBackgroundGradient = backgroundGradient === 'None' ? 'default' : backgroundGradient;

    const processedContent = replaceVariables(content);
    const processedFootnote = replaceVariables(restProps.footnote);

    const modifiedProps = {
        ...restProps,
        content: () => <div dangerouslySetInnerHTML={{ __html: processedContent || '' }} />,
        footnote: processedFootnote,
        backgroundColor: (processedBackgroundColor || 'White') as MilanBackgroundColors,
        backgroundGradient: processedBackgroundGradient as MilanGradientColors,
        backgroundImage,
        className: `mcl-mx-auto mcl-px-4 sm:mcl-px-0 ${topPaddingClasses} ${bottomPaddingClasses} [&_p]:mb-0`,
    };

    const backgroundColorClass = processBackgroundAndGradientColorMap({
        backgroundColor: (processedBackgroundColor as MilanBackgroundColors) || 'White',
        gradientColor: processedBackgroundGradient || 'None',
    });

    return (
        <div className={`${backgroundColorClass}`}>
            <S10PressReleasePost {...modifiedProps} />
        </div>
    );
}
